import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Button } from 'components/Button/Button';
import { InputComponent } from 'components/Input/Input';
import Spinner from 'components/Spinner/Spinner';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { updateUserProfile } from 'services/auth/auth.service';
import { getUserPackages } from 'services/auth/packages.service';
import { colors } from 'styles';
import { H3 } from '../../styles/FontStyles';
import { Div } from '../../styles/Styles';
import { ProfileUpload } from './FileUpload';

export const EditProfile = () => {
  const navigate = useNavigate();
  const { loading, userPackages } = useAppSelector((state) => state.packages);
  const { user } = useAppSelector((state) => state.authentication);
  const dispatch = useAppDispatch();
  const [image, setImage] = useState<File | null>(null);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [username, setUsername] = useState('');
  const letterUpercaseAndSpace = /^[a-zA-Z\s]*$/;

  useEffect(() => {
    dispatch(getUserPackages());
  }, [dispatch]);

  useEffect(() => {
    if (!user) return;
    setFirstName(user!.firstName);
    setLastName(user!.lastName);
    setUsername(user!.username);
  }, [user]);

  const checkFirstName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      setFirstName(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  const checkLastName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      setLastName(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  const onFormSubmit = (e: FormEvent) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('username', username);

    if (image) {
      formData.append('profileImage', image);
    }

    dispatch(updateUserProfile(formData));
    setImage(null);
  };

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}

      <Div $width='65%' $widthSM='100%'>
        <H3 color={colors.white} mb='20'>
          Edit Profile
        </H3>
        <Div $maxWidth='400px' $maxWidthSM='100%'>
          <form onSubmit={onFormSubmit}>
            <ProfileUpload image={image} setImage={setImage} />
            <InputComponent
              placeholder='Name'
              label='First name'
              value={firstName}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                checkFirstName(e.target.value)
              }
            />
            <InputComponent
              placeholder='Surname'
              label='Last name'
              value={lastName}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                checkLastName(e.target.value)
              }
            />
            <InputComponent
              placeholder='Username'
              label='Username'
              value={username}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setUsername(e.target.value)
              }
            />

            <Div $m='20px 0'></Div>

            <Button
              type='submit'
              disabled={!firstName || !lastName || !username}
            >
              Update Profile
            </Button>
          </form>
        </Div>
      </Div>
    </>
  );
};
